module.exports = __webpack_public_path__ + "img/results-bg.536e6d32.jpg";